module.exports = __webpack_public_path__ + "img/atul.08a6feab.jpg";